import ExternalLink from '@/components/Icons/CustomIcons/external-link.svg';
import { useSettings } from '@/services/settings/settings.service';
import Chip from '@mui/material/Chip';
import { FC, useEffect, useState, useCallback } from 'react';
import { logout } from '../../services/auth/auth.service';
import Button from '../Button/Button';
import { ButtonVariants } from '../Button/Button.types';
import Link from '../Link/Link';
import styles from './Header.module.css';
import { HeaderProps } from './Header.types';
import { useTranslation } from 'react-i18next';
import { useSTKContext } from '@/context/context';
import classNames from 'classnames';
import { Calendar } from 'react-feather';
import { useQueryClient } from '@tanstack/react-query';

const Header: FC<HeaderProps> = ({
  title,
  breadcrumb,
  includeLogOut = false,
  includeReportsLink = false,
  additionalTitleInfo,
  onClickAdditional,
  isFranchiseeUser = false,
  includeCalenderLink = false,
}) => {
  const { t } = useTranslation();
  const { apiClient } = useSTKContext();
  const queryClient = useQueryClient();

  const logoutCallback = useCallback(() => {
    logout(apiClient, queryClient);
  }, [apiClient]);
  const { data } = useSettings(title === 'Store Menus' || title === 'Menus');
  const [powerbiURL, setPowerbiURL] = useState('');

  useEffect(() => {
    if (data?.data) {
      for (const setting of data.data) {
        if (setting.setting_key === 'power_bi_url') setPowerbiURL(setting.setting_value);
      }
    }
  }, [data?.data]);
  return (
    <div
      className={classNames(styles.header, {
        [styles.franchiseeOn]: !isFranchiseeUser,
        [styles.franchiseeOff]: isFranchiseeUser,
      })}
    >
      {title && (
        <h1>
          {title}
          &nbsp;
          {additionalTitleInfo && (
            <Chip
              variant="outlined"
              onClick={onClickAdditional}
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                height: '28px',
                backgroundColor: 'white',
                color: '#266DCC',
                borderColor: '#266DCC',
                borderWidth: '1px',
                paddingLeft: '8px',
                paddingRight: '8px',
                '.MuiChip-label': {
                  paddingLeft: '0px',
                  paddingRight: '0px',
                },
              }}
              label={additionalTitleInfo}
            />
          )}
        </h1>
      )}

      {breadcrumb && (
        <Link to={breadcrumb.to} onClick={breadcrumb.onClick} id="skipNavTarget">
          {breadcrumb.label}
        </Link>
      )}
      {includeLogOut && (
        <Button variant={ButtonVariants.Text} onClick={logoutCallback} className={styles.logoutButton}>
          {t('common.logOut')}
        </Button>
      )}
      {includeReportsLink && (
        <div className={styles.reportsLink}>
          <Link to={powerbiURL} id="menuReportsLink" target="_blank">
            {t('header.viewReports')} &nbsp;
            <img src={ExternalLink} alt="externalLink" height="16px" />
          </Link>
        </div>
      )}
      {includeCalenderLink && (
        <div className={styles.infoMessage}>
          <div className={styles.iconMessage}>
            <Calendar color="var(--blue-700)" size={32} />
            <div className={styles.changesEffect}>
              <div>{t('menu.calendar.label1')}</div>
              <div>
                <span>{t('menu.calendar.label3')}</span>
              </div>
            </div>
          </div>
          <div className={styles.checkCalendar}>
            {t('menu.calendar.label4')}
            <Link to="/calendar" className={styles.calendarlink}>
              {t('menu.calendar.label5')}
            </Link>
            {t('menu.calendar.label6')}
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
